import { Injectable } from '@angular/core'
import { SegmentTagV2, SegmentPageProperties } from 'src/app/shared/analytics/models/segment-tag.model'
import { SegmentService } from 'src/app/shared/analytics/services/segment.service'

/**
 * The standard Page tag for the article list page view.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 * @see SegmentTagV2
 */
export const SEARCH_LIST_TAG: SegmentTagV2 = {
  page_category: 'Search',
  category: 'Search',
  autoPageCall: false
}

@Injectable()
export class OldSearchAnalyticsService {
  public constructor(private readonly segment: SegmentService) {}

  public sendPageCall(pageProperties: SegmentPageProperties = { _tag: 'list' }): void {
    this.segment.pageV2(SEARCH_LIST_TAG, pageProperties)
  }
}
